module.exports = __webpack_public_path__ + "assets/img/benefit-8.c2541784.svg";